import { auth0 } from "@/services/auth0";
import { getUserRoles } from "../current-user";

export function computePermissionForCurrentUser(componentPermissions: string | string[]) {
  const userRoles = getUserRoles()

  if (!componentPermissions?.length || componentPermissions == "*") return true;

  if (typeof componentPermissions === 'string') {
    componentPermissions = [componentPermissions];
  }

  if (componentPermissions.some((p: any) => userRoles.includes(p))) {
    return true;
  } else {
    return false;
  } 
}

const directive = {
  // called right before the element is inserted into the DOM.
  beforeMount(el, binding, vnode, prevVnode) {
    if (!computePermissionForCurrentUser(binding.value)) {
      el.parentNode?.removeChild(el);
    }
  },

  mounted(el, binding) {
    if (!computePermissionForCurrentUser(binding.value)) {
      el.parentNode?.removeChild(el);
    }
  },

  updated(el, binding) {
    if (!computePermissionForCurrentUser(binding.value)) {
      el.parentNode?.removeChild(el);
    }
  },
}

export default directive;